// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221506/js/" + chunkId + "." + {"44":"ca88dc85","225":"8184a713","481":"1a6ce63d","486":"f0d63440","770":"371087f2"}[chunkId] + ".0.5481238792871911.chunk.js";
};